<template>
    <el-cascader v-model="val" :options="options" :props="{checkStrictly: true}"
                 :show-all-levels="false" filterable clearable @change="onChange"></el-cascader>
</template>

<script>
    export default {
        props: ["value"],
        data() {
            return {
                options: [],
                val: [this.value ? this.value : this.$root.code]
            }
        },
        mounted() {
            if (this.$root.isAdmin) {
                this.$root.customers.forEach(customer => {
                    let option = {value: customer['value'], label: customer['label'], children: []};

                    this.$root.businesses.forEach(business => {
                        if (business.value.indexOf(customer.value) === 0) {
                            option.children.push({value: business['value'], label: business['label']});
                        }
                    });
                    this.options.push(option);
                });
            } else {
                this.onChange(this.val);

                this.$root.businesses.forEach(business => {
                    this.options.push({value: business['value'], label: business['label']});
                })
            }
        },
        watch: {
            value(val) {
                if (val) {
                    if (val instanceof Array) {
                        this.val = val;
                    } else {
                        if (val.length > 5 && this.$root.isAdmin) {
                            this.val = [val.substring(0, 5), val];
                        } else {
                            this.val = [val];
                        }
                    }
                } else {
                    this.val = [];
                }
            }
        },
        methods: {
            onChange(val) {
                this.$emit('input', val[val.length - 1]);
                this.$emit('change', val[val.length - 1]);
            }
        }
    }
</script>